import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { COURSE_TYPES_QUERY } from '../graphql/queries'
import { COMMON_FETCH_COURSE_TYPES } from '../redux/action-types'
import { cleanupCommonFetchCourseTypes } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useCourseTypesQuery = filters => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchCourseTypes)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.courseTypes,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        COURSE_TYPES_QUERY,
        { filters },
        dispatch,
        COMMON_FETCH_COURSE_TYPES,
      ),
    [dispatch, filters],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useCourseTypesQuery
